import React from 'react';
import PropTypes from 'prop-types';
var TabPanel = function TabPanel(_ref) {
  var component = _ref.component,
    id = _ref.id,
    activeTab = _ref.activeTab;
  var Component = component;
  return React.createElement('div', null, id === activeTab && React.createElement(Component, null));
};
process.env.NODE_ENV !== "production" ? TabPanel.propTypes = {
  component: PropTypes.func,
  id: PropTypes.string,
  activeTab: PropTypes.string
} : void 0;
export default TabPanel;